import React from 'react'
import { MessagesSidebar } from 'application/components/building_blocks/sidebar'

const SettingsSidebarComponent = () => {
    return <React.Fragment>
        <MessagesSidebar />
    </React.Fragment>
} 

export default SettingsSidebarComponent